import { action, computed } from 'mobx';
import Time from 'services/base/time';
import { NumberStore, StringStore } from 'ui/base/input';
import { ModalStore } from 'ui/base/modal';

export class ClockInputStore {
  hours: NumberStore;
  minutes: NumberStore;

  tempHours: NumberStore;
  tempMinutes: NumberStore;
  tempAMPM: StringStore;

  modal: ModalStore;

  constructor(time: Time) {
    this.hours = new NumberStore(0);
    this.minutes = new NumberStore(0);
    this.tempHours = new NumberStore(0);
    this.tempMinutes = new NumberStore(0);
    this.tempAMPM = new StringStore('');

    this.modal = new ModalStore(false);

    this.setTime(time);
  }

  @action.bound
  setTime(time: Time): void {
    const am = time.hours < 12;
    const clockHours = time.hours - (am ? 0 : 12);
    const clockMinutes = time.minutes;
    this.hours.setValue(time.hours);
    this.minutes.setValue(time.minutes);
    this.tempHours.setValue(clockHours);
    this.tempMinutes.setValue(clockMinutes);
    this.tempAMPM.setValue(am ? 'AM' : 'PM');
  }

  @action.bound
  reloadTime(): void {
    this.setTime(this.committedTime);
  }

  @action.bound
  commitTime(): void {
    this.setTime(this.tempTime);
  }

  @computed get tempTime(): Time {
    const am = this.tempAMPM.value === 'AM';
    const realHours = (this.tempHours.value % 12) + (am ? 0 : 12);
    const realMinutes = this.tempMinutes.value;
    return new Time(realHours, realMinutes, 0);
  }

  @computed get committedTime(): Time {
    const realHours = this.hours.value;
    const realMinutes = this.minutes.value;
    return new Time(realHours, realMinutes, 0);
  }
}
